import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import RoomApi from "api/room.api";
import {serviceRoomDestroy, serviceRoomSave, serviceRoomUpdateAction} from "services/room.service";

const RoomContext = createContext();

export const RoomProvider = ({children}) => {

    const translateKey = 'crm.Room';
    const permission = 'room';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false
    });

    const {dataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(RoomApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id, action = 'is_active') => {
        const res = await serviceRoomUpdateAction(id, action);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await serviceRoomDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await serviceRoomSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave
    };

    return <RoomContext.Provider value={values}>
        {children}
    </RoomContext.Provider>
}

export const useRoomContext = () => useContext(RoomContext);
